import Header from "@components/configurations/header";
import {ReactComponent as ProjectAccessSettingIcon} from "@assets/sideMenuIcon/project_access_setting.svg"
import styled from "@emotion/styled";
import { Box } from "@mui/system";
import { CompactFieldRow } from "@components/configurations/form/compactFieldRow";
import { FormTextField } from "@components/configurations/form/textfield";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const FormBox = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
}));

export const PasswordSettingForm = () => {

  const { control } = useFormContext();
  const { t } = useTranslation();


  return (
    <>
      <Header title={"Password"} icon={<ProjectAccessSettingIcon width={"35px"} height={"35px"}/>}/>
      <FormBox>
      <CompactFieldRow
          firstchildren={
            <FormTextField
              name="current_password"
              control={control}
              label={t("Old Password")}
              type={'password'}
            />
          }
          secondchildren={
            <FormTextField
              name="new_password"
              control={control}
              label={t("New Password")}
              type={'password'}
            />
          }
        />
        <CompactFieldRow
          firstchildren={
            <FormTextField
              name="confirm_password"
              control={control}
              label={t("Confirm Password")}
              type={'password'}
            />
          }
          secondchildren={
            <></>
          }
        />
      </FormBox>
    </>
  )
};
